export class ExternalAgentShort {
  agentName: string;
  baseUrl: string;

  constructor(data: any) {
    this.agentName = data.agentName;
    this.baseUrl = data.baseUrl;
  }
}

export interface FunctionParameter {
  name: string;
  type: "string" | "number" | "boolean";
  description: string;
  required: boolean;
  min?: number;
  max?: number;
}

export interface FunctionParameters {
  properties: Record<
    string,
    {
      type: string;
      description: string;
      min?: number;
      max?: number;
    }
  >;
  required: string[];
  type: "object";
}

export class ExternalAgent extends ExternalAgentShort {
  llmName: string;
  agentFunctionName: string;
  agentFunctionDescription: string;
  systemPrompt: string;
  searchFunctionDescription: string;
  searchFunctionParameters: FunctionParameters;
  retrieveFunctionDescription: string;
  retrieveFunctionParameters: FunctionParameters;

  constructor(data: any) {
    super(data);
    this.llmName = data.llmName;
    this.agentFunctionName = data.agentFunctionName;
    this.agentFunctionDescription = data.agentFunctionDescription;
    this.systemPrompt = data.systemPrompt;
    this.searchFunctionDescription = data.searchFunctionDescription;
    this.searchFunctionParameters = data.searchFunctionParameters;
    this.retrieveFunctionDescription = data.retrieveFunctionDescription;
    this.retrieveFunctionParameters = data.retrieveFunctionParameters;
  }
}
